import { CampaignDetailPage } from "@/features/campaign/pages/CampaignDetailPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/campaign/$id/detail")({
	component: RouteComponent,
});

function RouteComponent() {
	const { id } = Route.useParams();
	return <CampaignDetailPage id={id} />;
}
